<template>
    <!--检查规范-->
    <div class="specify">
        <div class="specify-content">
            <div class="grid-content" v-loading="specifyLoading">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-button @click="addSpecify"
                                class="btnDe"
                                size="mini"
                                v-has="'add-perm'"
                        >新增检查规范</el-button>
                    </el-col>
                    <!--搜索-->
                    <el-col :span="20" class="input_wrapper">
                        <el-form
                                class="searchForm"
                                ref="searchForm"
                                :model="searchForm"
                                size="mini"
                                inline
                        >
                            <!--:disabled="loading"-->
                            <SearchForm
                                    :searchList="searchList"
                                    @seacrhMethod="seacrhMethod"
                            ></SearchForm>
                        </el-form>
                    </el-col>
                </el-row>
                <div>
                    <!--异常产品列表-->
                    <el-table
                            :data="specifyList"
                            :height="heightAll - 110"
                            style="width: 100%;margin: 10px 0px"
                    >
                        <el-table-column
                                prop="sort"
                                :show-overflow-tooltip="true"
                                label="序号"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="content"
                                :show-overflow-tooltip="true"
                                label="规范内容"
                        >
                        </el-table-column>
                        <el-table-column
                                align="center"
                                prop="specifyList.addUserName"
                                label="添加人"
                        >
                        </el-table-column>


                        <el-table-column label="操作" width="200" align="center">
                            <template slot-scope="scope">
                                <el-button
                                        type="text" @click="updateSpecify(scope.row)"
                                        class="btnDe-text"
                                        size="mini"
                                        v-has="'modify-perm'"
                                >编辑</el-button>
                                <el-button  @click="delSpecify(scope.row)"
                                        v-has="'del-perm'"
                                        size="mini"
                                        type="text"
                                        class="btnDanger-text"
                                >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页-->
                    <el-row>
                        <div class="fiexPos">
                            <Pagination
                                    :handleSizeChange="handleSizeChange"
                                    :handleCurrentChange="handleCurrentChange"
                                    :currentPage="currentPage"
                                    :pagesize="pageSize"
                                    :total="total"
                            >
                            </Pagination>
                        </div>
                    </el-row>
                </div>
                <addSpecify v-if="specifyDialog" :specifyDialog="specifyDialog" :currentMenuId="currentMenuId" :transferData="transferData"  @loadList="getSpection" @closeAddSpecify="closeAddSpecify"></addSpecify>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
  import Pagination from "@/components/core/Pagination";
  import SearchForm from "@/components/core/SearchForm";
  import addSpecify from "./specifyComponents/addSpecify";
  import { delSpecification, getspecificationList } from "../../api/module/checkSpecification";

export default {
  name: "Specification",
  components:{
    Pagination,addSpecify,SearchForm
  },
  computed:{
    ...mapGetters(['currentMenuId'])
  },
  props: ["heightAll"],
  data(){
    return {
      pageSize:10,
      currentPage:1,
      total:10,
      specifyList:[],
      specifyLoading: false,
      specifyDialog: false,
      transferData:{},
      // 搜索条件
      searchForm: {
        content:'',
      },
      searchList: {
        content: {
          label: '规范内容',
          itemwidth: '258px',
          type: 'input',
          key: 'content',
          value: '',
        },
      },
    }
  },
  methods:{
    // 分页操作
    handleSizeChange(val) {
      this.pageSize = val;
      this.getSpection()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getSpection()
    },
    // 获取规范列表
    getSpection(){
      this.specifyLoading = true
      let param = new FormData()
      param.append('currentPage', this.currentPage)
      param.append('pageSize', this.pageSize)
      if(this.searchForm.content){
        param.append('content', this.searchForm.content)
      }

      getspecificationList(param,res=>{
        // console.log(res)
        this.specifyLoading = false
        this.specifyList =   res.obj.list
        this.total =   res.obj.total
      },()=>{
        this.specifyLoading = false
        // console.log(error)
      },this.currentMenuId)
    },
    addSpecify(){
      this.specifyDialog = true
      this.transferData = {
        name:'add',
        total: this.total
      }
    },
    closeAddSpecify(fg){
      this.specifyDialog = fg
    },
    updateSpecify(row){
      this.specifyDialog = true
      this.transferData = {
        name:'update',
        detail:row
      }
    },
    // 删除
    delSpecify(row){
      let delparam = new FormData()
      delparam.append('id',row.id)
      delSpecification(delparam,res=>{
        // console.log(res)
          if (res.success) {
              this.$message({
                  type: "success",
                  message: '删除成功!',
              });
              this.getSpection()// 更新列表
          }

      },()=>{},this.currentMenuId)
    },
    //搜索
    seacrhMethod(data) {
      this.currentPage = 1;
      this.searchForm.content = data.content
      this.getSpection()
    }
  },
  mounted() {
    this.getSpection()
  }
};
</script>

<style scoped>
    .specify{
        background: white;
        overflow: hidden;
    }
    .specify > .specify-content {
        padding: 10px;
    }
    .input_wrapper{
        float: right;
    }
</style>
